import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { useRouter } from 'next/router'

import { useAuth } from '../../../hooks/auth'
import ProfileModal from '../user/profile-modal'
import { isValidCui, requiresCui } from '../utils/cui'

const HIDDEN_ROUTES = ['/perfil', '/auth']

const isHiddenRoute = (pathname) => HIDDEN_ROUTES.some(route => pathname.startsWith(route))

const ProfileCheck = ({ children }) => {
    const auth = useAuth()
    const router = useRouter()
    const [showModal, setShowModal] = useState(false)
    const [missingLocation, setMissingLocation] = useState(false)
    const [invalidIdCard, setInvalidIdCard] = useState(false)

    useEffect(() => {
        if (isHiddenRoute(router.pathname)) {
            setShowModal(false)
            return
        }

        if (auth && auth.isAuthenticated && auth.user) {
            const userCountry = get(auth, 'user.country', null)
            const userMunicipality = get(auth, 'user.municipality', null)
            const userIdCard = get(auth, 'user.idCard', '')

            const isMissingLocation = !userCountry || (userCountry === 'Guatemala' && !userMunicipality)
            const isInvalidIdCard = requiresCui(userCountry) && !isValidCui(userIdCard)

            setMissingLocation(isMissingLocation)
            setInvalidIdCard(isInvalidIdCard)
            setShowModal(isMissingLocation || isInvalidIdCard)
        }
    }, [auth, router.pathname])

    return (
        <>
            {children}

            {auth && auth.isAuthenticated && auth.user && !isHiddenRoute(router.pathname) && (
                <ProfileModal
                    open={showModal}
                    username={get(auth, 'user.firstName', '')}
                    missingLocation={missingLocation}
                    invalidIdCard={invalidIdCard}
                />
            )}
        </>
    )
}

ProfileCheck.propTypes = {
    children: PropTypes.node
}

export default ProfileCheck
